<template>
  <UsersTable />
</template>

<script>
import UsersTable from '../components/common/Table/UserTable/UsersTable'

export default {
  components: { UsersTable },
  data () {
    return {}
  }
}
</script>
